// assets/product-stock.js
(function($) {
  'use strict';

  // 商品在庫・バリエーション管理処理
  function initProductStock() {
    const form = $('.AddToCartForm');
    if (!form.length) return;

    const productSelect = form.find('input#productSelect');
    const quantity = form.find('select[name="quantity"]');
    let maxquantity;

    function getOptionID() {
      const colorInputs = form.find('input[data-option="color"]');
      const sizeInputs  = form.find('input[data-option="size"]');

      // ① カラー & サイズ
      if (colorInputs.length && sizeInputs.length) {
       

        const selectColor = colorInputs.filter(':checked').val();

        sizeInputs.each(function() {
          const sizeVal = $(this).val();
          const optionData = $(`.js-variant[data-color="${selectColor}"][data-size="${sizeVal}"]`);
          if (optionData.data('available') === true) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true).prop('checked', false);
          }
        });

        if (!sizeInputs.is(':checked')) sizeInputs.filter(':not(:disabled)').first().prop('checked', true);
        if (!colorInputs.is(':checked')) colorInputs.filter(':not(:disabled)').first().prop('checked', true);
      }

      // ② カラーのみ
      else if (colorInputs.length && !sizeInputs.length) {
        colorInputs.each(function() {
          const colorVal = $(this).val();
          const colorOption = $(`.js-variant[data-color="${colorVal}"]`);
          if (colorOption.data('available') === true) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true).prop('checked', false);
          }
        });
         if (!colorInputs.is(':checked')) colorInputs.filter(':not(:disabled)').first().prop('checked', true);
      }

      // ③ サイズのみ
      else if (!colorInputs.length && sizeInputs.length) {

        sizeInputs.each(function() {
          const sizeVal = $(this).val();
          const sizeOption = $(`.js-variant[data-size="${sizeVal}"]`);
          console.log(sizeOption,sizeVal,'sizeOption' )
          if (sizeOption.data('available') === true) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true).prop('checked', false);
          }
        });

         if (!sizeInputs.is(':checked'))  sizeInputs.filter(':not(:disabled)').first().prop('checked', true);
      }

      // ④ 選択済みオプションからVariant取得
      const selectColor = colorInputs.filter(':checked').val();
      const selectSize  = sizeInputs.filter(':checked').val();
      let itemData;

      if (selectColor && selectSize)
        itemData = $(`.js-variant[data-color="${selectColor}"][data-size="${selectSize}"]`);
      else if (selectColor)
        itemData = $(`.js-variant[data-color="${selectColor}"]`);
      else if (selectSize)
        itemData = $(`.js-variant[data-size="${selectSize}"]`);
      else
        itemData = $('.js-variant').first();

      if (itemData && itemData.length) {
        const variantId = itemData.data('variant-id');
        form.find('input[name="id"]').val(variantId);
      }

      // 数量制御
      let currentQuantity = quantity.val();
      if (itemData.length && itemData.data('quantity') !== undefined) {
        maxquantity = itemData.data('quantity');
        if (maxquantity !== 0) {
          quantity.empty().append(`<option>${labels[locale].quantity}</option>`);
          for (let i = 1; i <= Math.min(maxquantity, 5); i++) {
            quantity.append(`<option value="${i}" ${currentQuantity == i ? 'selected' : ''}>${i}</option>`);
          }
          quantity.prop('disabled', false);
        } else {
          quantity.html(`<option value="0">${labels[locale].outofstock}</option>`).prop('disabled', true);
        }
      } else {
        // 在庫追跡なし／無制限販売
        quantity.empty().append(`<option>${labels[locale].quantity}</option>`);
        for (let i = 1; i <= 5; i++) {
          quantity.append(`<option value="${i}" ${currentQuantity == i ? 'selected' : ''}>${i}</option>`);
        }
        quantity.prop('disabled', false);
      }

      // 予約販売・AddToCart制御
      const schedule = $('.js-shipping-schedule');
      const addToCart = form.find('button[name="add"]');
      const currentLabels = labels[locale] || labels.ja;

      if (isPurchaseLocked()) {
        if (itemData.length && itemData.data('shippingschedule')) {
          schedule.text(itemData.data('shippingschedule'));
        } else {
          schedule.empty();
        }
        addToCart.addClass('disabled').prop('disabled', true);
        if (form.hasClass('is-unreleased')) {
          addToCart.css({ opacity: '', cursor: 'not-allowed' })
            .find('.js-AddToCart-label').text(currentLabels.comingsoon);
        } else {
          addToCart.css({ opacity: 0.5, cursor: 'not-allowed' });
        }
        return;
      }

      if (itemData.length && itemData.data('shippingschedule')) {
        schedule.text(itemData.data('shippingschedule'));
        productSelect.val(itemData.data('id'));
        addToCart.removeClass('disabled').prop('disabled', false)
          .css({ opacity: '', cursor: '' })
          .find('.js-AddToCart-label').text(currentLabels.preorder);
      } else {
        schedule.empty();
        const variantID = itemData.data('id');
        if (itemData.data('available') === true) {
          productSelect.val(variantID);
          addToCart.removeClass('disabled').prop('disabled', false)
            .css({ opacity: '', cursor: '' })
            .find('.js-AddToCart-label').text(currentLabels.addtocart);
        } else {
          addToCart.addClass('disabled').prop('disabled', true)
            .css({ opacity: 0.5, cursor: 'not-allowed' })
            .find('.js-AddToCart-label').text(currentLabels.outofstock);
        }
      }
    }

    function isPurchaseLocked() {
      return form.hasClass('is-unreleased') || form.hasClass('is-us-blocked');
    }

    function parseReleaseDate() {
      const ts = Number(form.attr('data-release-ts') || form.find('.js-release-at').attr('data-release-ts'));
      if (ts) return new Date(ts * 1000);

      const iso = form.attr('data-release-at') || form.find('.js-release-at').attr('data-release-at');
      if (!iso) return null;

      const normalized = String(iso).replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      const date = new Date(normalized);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    function formatReleaseLabel(date) {
      if (typeof formatCardReleaseDate === 'function') {
        return formatCardReleaseDate(date);
      }

      const isEn = String(locale).toLowerCase().indexOf('en') === 0;
      const pad = function (n) {
        return String(n).padStart(2, '0');
      };
      const formatted = date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate())
        + ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
      return isEn ? ('Release: ' + formatted) : ('発売日：' + formatted);
    }

    function localizeReleaseNote() {
      const note = form.find('.js-release-at');
      const date = parseReleaseDate();
      if (!note.length || !date) return;
      note.text(formatReleaseLabel(date));
    }

    function unlockIfReleased() {
      if (!form.hasClass('is-unreleased')) return false;

      const date = parseReleaseDate();
      if (!date || Date.now() < date.getTime()) return false;

      form.removeClass('is-unreleased');
      form.find('.js-release-note, .js-release-at').remove();
      getOptionID();
      return true;
    }

    function scheduleReleaseUnlock() {
      if (!form.hasClass('is-unreleased')) return;

      const date = parseReleaseDate();
      if (!date) return;

      const tick = function() {
        if (unlockIfReleased()) return;
        const wait = Math.max(250, Math.min(date.getTime() - Date.now(), 60 * 1000));
        window.setTimeout(tick, wait);
      };

      tick();
      $(document).on('visibilitychange.productRelease', function() {
        if (document.visibilityState === 'visible') unlockIfReleased();
      });
    }

    localizeReleaseNote();
    scheduleReleaseUnlock();

    // 初回実行＋イベント監視
    getOptionID();
    form.on('change', getOptionID);

    // submit時バリデーション
    form.on('submit', function() {
      if (isPurchaseLocked() || productSelect.val() === 'undefined' || form.find('button[name="add"]').prop('disabled')) {
        console.log('オプション・数量を選択してください');
        return false;
      }
    });
  }

  // DOM読み込み後に初期化
  $(document).ready(initProductStock);

})(jQuery);